<script setup lang="ts">

import { reactive } from "vue"

const emits = defineEmits(['metaAdded', 'metaUpdated'])
const props = defineProps([
    "existingMeta",
    "metaTitle",
    "hasColor",
    "hasEmail",
    "hasPhone",
    "hasAddress",
    "hasLocation"
])

const meta = reactive<Record<string, any>>({
    id: props.existingMeta?.id ?? "",
    name: props.existingMeta?.name ?? "",
    color: props.existingMeta?.color ?? "#2563eb",
    email: props.existingMeta?.email ?? "",
    phone: props.existingMeta?.phone ?? "",
    address: props.existingMeta?.address ?? "",
    location: props.existingMeta?.location ?? "",
})

// Build a clean payload that only includes the fields enabled for this meta type.
const buildPayload = () => {
    const payload: Record<string, any> = { name: meta.name }
    if (props.hasColor) payload.color = meta.color
    if (props.hasEmail) payload.email = meta.email
    if (props.hasPhone) payload.phone = meta.phone
    if (props.hasAddress) payload.address = meta.address
    if (props.hasLocation) payload.location = meta.location
    return payload
}

const emitAddMeta = () => {
    if (!meta.name) {
        alert(`Lütfen ${props.metaTitle?.toLowerCase()} adını giriniz.`)
        return
    }
    emits('metaAdded', buildPayload())
}

const emitUpdateMeta = () => {
    if (!meta.name) {
        alert(`Lütfen ${props.metaTitle?.toLowerCase()} adını giriniz.`)
        return
    }
    emits('metaUpdated', { id: meta.id, ...buildPayload() })
}

const handleFormSubmit = () => {
    if (props.existingMeta) {
        emitUpdateMeta()
    } else {
        emitAddMeta()
    }
}

</script>

<template>
    <form class="ac-main-form !border-none">
        <div class="ac-form-control">
            <label for="title">
                {{ props.metaTitle }} Adı
            </label>
            <input type="text" id="title" v-model="meta.name">
        </div>

        <div v-if="props.hasEmail" class="ac-form-control">
            <label for="email">E-posta</label>
            <input type="email" id="email" v-model="meta.email">
        </div>

        <div v-if="props.hasPhone" class="ac-form-control">
            <label for="phone">Telefon</label>
            <input type="text" id="phone" v-model="meta.phone">
        </div>

        <div v-if="props.hasAddress" class="ac-form-control">
            <label for="address">Adres</label>
            <textarea id="address" rows="3" v-model="meta.address"></textarea>
        </div>

        <div v-if="props.hasLocation" class="ac-form-control">
            <label for="location">Lokasyon</label>
            <input type="text" id="location" v-model="meta.location">
        </div>

        <div v-if="props.hasColor" class="ac-form-control">
            <label for="color">Renk</label>
            <input type="color" id="color" class="w-full" v-model="meta.color">
        </div>

        <div class="ac-form-control">
            <button type="button" class="ac-primary-button w-2/6" @click="handleFormSubmit">
                <span v-if="!existingMeta"> {{ props.metaTitle }} Oluştur </span>
                <span v-else> {{ props.metaTitle }} Güncelle </span>
            </button>
        </div>
    </form>
</template>
